import { render } from "./createModalComponent.vue?vue&type=template&id=3007a223"
import script from "./createModalComponent.vue?vue&type=script&lang=js"
export * from "./createModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__